import { useMemo } from 'react';
import { FundChartPoint } from '../types/fundsummary.type';

type ProcessChartData = {
  nav: FundChartPoint[];
  benchmark: FundChartPoint[];
  tna: FundChartPoint[];
  baseData: FundChartPoint[];
};

const useProcessChartData = (
  navData: FundChartPoint[] = [],
  midData: FundChartPoint[] = [],
  tnaData: FundChartPoint[] = [],
): ProcessChartData => {
  const baseData = useMemo(() => {
    const maxLength = Math.max(navData.length, midData.length, tnaData.length);
    if (maxLength === tnaData.length) {
      return tnaData;
    }
    if (maxLength === navData.length) {
      return navData;
    }
    return midData;
  }, [navData, midData, tnaData]);

  const { nav, benchmark, tna } = useMemo(() => {
    if (baseData.length === 0) {
      return { nav: [], benchmark: [], tna: [] };
    }

    const baselineDate =
      tnaData[0]?.Date || navData[0]?.Date || midData[0]?.Date;
    const navBaselineItem = navData.find((item) => item.Date === baselineDate);
    const navBaselineValue = navBaselineItem
      ? parseFloat(navBaselineItem.val.toString())
      : 0;

    const midBaselineItem = midData.find((item) => item.Date === baselineDate);
    const midBaselineValue = midBaselineItem
      ? parseFloat(midBaselineItem.val.toString())
      : 0;
    // Change absoluted value to persentage value;
    const processNavData = navData.map((item) => {
      const value = parseFloat(item.val.toString());
      let persentValue = 0;
      if (navBaselineValue !== 0) {
        persentValue = ((value - navBaselineValue) / navBaselineValue) * 100;
      }
      return {
        ...item,
        val: persentValue,
      };
    });
    // Change absoluted value to persentage value;
    const processBenchmarkData = midData.map((item) => {
      const value = parseFloat(item.val.toString());
      let persentValue = 0;
      if (midBaselineValue !== 0) {
        persentValue = ((value - midBaselineValue) / midBaselineValue) * 100;
      }
      return {
        ...item,
        val: persentValue,
      };
    });

    return {
      nav: processNavData,
      benchmark: processBenchmarkData,
      tna: [...tnaData],
    };
  }, [baseData, navData, midData, tnaData]);

  return { nav, benchmark, tna, baseData };
};
export default useProcessChartData;
